import * as BasePopover from "@radix-ui/react-popover";
import { filterClasses } from "@swivl-mono/helpers";

export enum PopoverPosition {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right"
}

interface PopoverProps {
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  disabled?: boolean;
  trigger: React.ReactNode;
  children: React.ReactNode;
  position?: PopoverPosition;
  onInteractOutside?: (event: Event) => void;
  onEscapeKeyDown?: (event: KeyboardEvent) => void;
  onOpenAutoFocus?: (event: Event) => void;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
  styles?: React.CSSProperties;
  id?: string;
}

const Popover = ({
  isOpen,
  onOpenChange,
  disabled = false,
  trigger,
  children,
  position,
  side,
  className,
  id,
  styles,
  onInteractOutside,
  onEscapeKeyDown,
  onOpenAutoFocus
}: PopoverProps) => {
  const handleOpenChange = (open: boolean) => {
    if (!disabled) {
      onOpenChange?.(open);
    }
  };

  return (
    <BasePopover.Root open={isOpen} onOpenChange={handleOpenChange}>
      <BasePopover.Trigger disabled={disabled} asChild>
        {trigger}
      </BasePopover.Trigger>

      {!disabled && (
        <BasePopover.Portal>
          <BasePopover.Content
            side={side}
            sideOffset={4}
            aria-disabled={disabled}
            align={position === PopoverPosition.LEFT ? "start" : position === PopoverPosition.CENTER ? "center" : "end"}
            onInteractOutside={onInteractOutside}
            onEscapeKeyDown={onEscapeKeyDown}
            onOpenAutoFocus={onOpenAutoFocus}
            id={id}
            className={filterClasses(
              "max-h-[min(486px,calc(var(--radix-popover-content-available-height)-16px))] w-(--radix-popover-trigger-width) overflow-y-auto",
              "z-600 rounded-md bg-white p-2",
              "shadow-[0_2px_4px_0_rgba(0,0,0,0.15),0_1px_1px_0_rgba(0,0,0,0.15)]",
              className || ""
            )}
            style={styles}
          >
            {children}
          </BasePopover.Content>
        </BasePopover.Portal>
      )}
    </BasePopover.Root>
  );
};

export { Popover };
